import { render, staticRenderFns } from "./Year11.vue?vue&type=template&id=910f7c3c&scoped=true&"
import script from "./Year11.vue?vue&type=script&lang=js&"
export * from "./Year11.vue?vue&type=script&lang=js&"
import style0 from "./Year11.vue?vue&type=style&index=0&id=910f7c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910f7c3c",
  null
  
)

export default component.exports